import {createReducer, on} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {CitizensFillableFormResponse} from './citizens-fillable-form-response.model';
import * as CitizensFillableFormResponseActions from './citizens-fillable-form-response.actions';

export const citizensFillableFormResponsesFeatureKey = 'citizensFillableFormResponses';

export interface State extends EntityState<CitizensFillableFormResponse> {
  // additional entities state properties
}

export const adapter: EntityAdapter<CitizensFillableFormResponse> = createEntityAdapter<CitizensFillableFormResponse>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(CitizensFillableFormResponseActions.addCitizensFillableFormResponse,
    (state, action) => adapter.addOne(action.citizensFillableFormResponse, state)
  ),
  on(CitizensFillableFormResponseActions.upsertCitizensFillableFormResponse,
    (state, action) => adapter.upsertOne(action.citizensFillableFormResponse, state)
  ),
  on(CitizensFillableFormResponseActions.addCitizensFillableFormResponses,
    (state, action) => adapter.addMany(action.citizensFillableFormResponses, state)
  ),
  on(CitizensFillableFormResponseActions.upsertCitizensFillableFormResponses,
    (state, action) => adapter.upsertMany(action.citizensFillableFormResponses, state)
  ),
  on(CitizensFillableFormResponseActions.updateCitizensFillableFormResponse,
    (state, action) => adapter.updateOne(action.citizensFillableFormResponse, state)
  ),
  on(CitizensFillableFormResponseActions.updateCitizensFillableFormResponses,
    (state, action) => adapter.updateMany(action.citizensFillableFormResponses, state)
  ),
  on(CitizensFillableFormResponseActions.deleteCitizensFillableFormResponse,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(CitizensFillableFormResponseActions.deleteCitizensFillableFormResponses,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(CitizensFillableFormResponseActions.loadCitizensFillableFormResponses,
    (state, action) => adapter.setAll(action.citizensFillableFormResponses, state)
  ),
  on(CitizensFillableFormResponseActions.clearCitizensFillableFormResponses,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
